"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_FLAGGED_REASONS = void 0;
var client_1 = require("@apollo/client");
exports.GET_FLAGGED_REASONS = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query GetFlaggedReasonsByType($flagType: FlaggedType!) {\n      flaggedReasonsByType(flagType: $flagType) {\n        flaggedReasons {\n          type\n          reason\n        }\n      }\n    }\n"], ["\n    query GetFlaggedReasonsByType($flagType: FlaggedType!) {\n      flaggedReasonsByType(flagType: $flagType) {\n        flaggedReasons {\n          type\n          reason\n        }\n      }\n    }\n"])));
var templateObject_1;
